import App from "@bloglovin/inspire-engine/App";

export { mergeEngineContexts } from "%/dynamic-component-editor/helpers/engine-contexts";

export function engineCurrentUserPk() {
  try {
    return App.getRoot().getCurrentUserEntityPk();
  } catch {
    return null;
  }
}
